export function truncateShareText(value: string, maxLength: number): string {
  return Array.from(value).slice(0, maxLength).join('');
}

export function mallReportShareContent(
  pointName: string | undefined,
  circleType: string | undefined,
  conclusion: string | undefined,
) {
  const title = truncateShareText(`${pointName || '商圈'}｜选址决策报告`, 30);
  const description = circleType && conclusion
    ? truncateShareText(`${circleType} · ${conclusion}`, 40)
    : '点击查看决策报告详情';
  return { title, description };
}

/** 复制到剪贴板的分享文本：{点位名称}｜决策报告：{短链} */
export function mallReportShareCopyText(pointName: string | undefined, url: string): string {
  return `${pointName || '商圈'}｜决策报告：${url}`;
}
